export default __webpack_public_path__ + "static/lower3_2-28993e074567a37b052167a19c25779b.jpg";